module.exports = __webpack_public_path__ + "media/Gespraeche.35903f72.mp3";